import React, { Fragment } from 'react'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import { Spinner } from 'components/Loaders/Loaders'

const CollapsibleTable = ({ rows, headers, className = '', getChildren, expandable }) => (
  <table className={`styled-table ${className}`}>
    <TableHeader headers={headers} expandable={expandable} />
    <TableBody rows={rows} getChildren={getChildren} expandable={expandable} />
  </table>
)

export default CollapsibleTable

const TableHeader = ({ headers, expandable }) => (
  <thead>
    <tr className={expandable ? "expandable" : ''}>
      {headers.map((h, i) => (
        <th key={i}>{h}</th>
      ))}
      {
        expandable &&
        <th></th>
      }
    </tr>
  </thead>
)

const TableBody = ({ rows, childType, getChildren, expanded, expandable }) => (
  <tbody>
    {rows.map((row, i) => (
      <Row cells={row.render} getChildren={getChildren} expandable={expandable} index={i} key={row.id || i} />
    ))}
  </tbody>
)

class Row extends React.Component {
  state = { expanded: false, fetching: false, children: null, error: false }
  toggleExpansion = () => {
    if(this.state.expanded){
      this.setState({expanded: false})
    }else{
      this.setState({fetching: true, error: false})
      this.props.getChildren(this.props.cells, this.props.index)
      .then(children => {
        this.setState({ expanded: true, fetching: false, children })
      })
      .catch(err => {
        console.error(err)
        this.setState({error: true, fetching: false, expanded: true})
      })
    }
  }
  render() {
    const { cells, expandable } = this.props
    return (
      <Fragment>
        <tr className="clickable" onClick={this.toggleExpansion}>
          {cells.map((cell, i) => (
            <td key={i}>{cell}</td>
          ))}
          {
            expandable &&
            <td className="expand-cell">
              {
                this.state.fetching ?
                <Spinner size="small" themeColor="inherit" />
                :
                <div className="expand-wrapper">
                  <CaretDownIcon className={this.state.expanded ? 'expanded' : ''} />
                </div>
              }
            </td>
          }
        </tr>
        {this.state.expanded && (
          <tr className="expansion-spacer">
            <td colSpan={cells.length}>{/* <div className="spacer" /> */}</td>
          </tr>
        )}
        {this.state.expanded && (
          <tr className="expanded-row">
            <td colSpan={cells.length + (expandable ? 1 : 0)}>
              <div className="child-wrapper">
                {
                  !this.state.fetching ?
                  this.state.children
                  :
                  "Loading..."
                }
                {
                  this.state.error &&
                  <span className="message danger-text">Something went wrong.</span>
                }
              </div>
            </td>
          </tr>
        )}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/CollapsibleTable.js